export const getRoleColumns = (t) => [
  {
    key: 'role_name',
    label: t('role_name'),
    align: 'text-left',
    classCell: 'flex',
  },
  { key: 'roles', label: t('role'), align: 'text-left' },
  { key: 'actions', label: '', align: 'text-right', classCell: 'flex' },
];

export const SearchIcon = (
  <svg
    className="w-5 h-5 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1115 3.5a7.5 7.5 0 011.65 14.15z"
    />
  </svg>
);
